import SectionTitle from '@ui/section-title'
import { Container, Row, Col } from '@ui/wrapper'
import {
  SectionWrapper,
  StyledText,
  SwiperWrapper,
  SlideItemWrapper
} from './style'
import HomeBox from '@components/box-large-image/layout-05'
import Image from '@ui/image'
import SwiperSlider, { SwiperSlide } from '@ui/swiper'
import { Link } from 'gatsby'
import './style.css'

const HomeArea = ({ data, ...rest }) => {
  const slider = {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    speed: 2000,
    spaceBetween: 50,
    mousewheel: false,
    keyboard: false,
    allowTouchMove: false,
    autoplay: {
      delay: 1000
    },
    pagination: false,
    navigation: false
  }

  return (
    <SectionWrapper {...rest}>
      <Container>
        {data?.section_title && (
          <SectionTitle
            mb="20px"
            title={data.section_title?.title}
            subtitle={data.section_title?.subtitle}
            description={data.section_title?.description}
          />
        )}
        {data?.texts?.[0] && (
          <StyledText
            dangerouslySetInnerHTML={{
              __html: data.texts[0].content
            }}
          />
        )}
        <Row>
          {data.items?.map(
            (item) =>
              item && (
                <Col
                  key={item.id}
                  style={{ marginBottom: 30 }}
                  className="box-item"
                  lg={4}
                  md={6}
                >
                  <HomeBox
                    title={item.title}
                    desc={item.description}
                    image={item.images[0]}
                    path={item.path}
                  />
                </Col>
              )
          )}
        </Row>
        <SwiperWrapper className="own-swiper-slide">
          <SwiperSlider options={slider} paginationTop="20px" opacityStyle>
            {data.images.map(
              (image, index) =>
                image.src && (
                  <SwiperSlide className="item" key={`image-${index}`}>
                    <SlideItemWrapper width={image.src.width}>
                      <Link
                        to={image.path || '/'}
                        aria-label={image.src.alternativeText || ''}
                      >
                        <Image
                          src={image.src.localFile || image.src}
                          alt={image.src.alternativeText || ''}
                          sizes="300px"
                          style={{ width: '100%' }}
                        />
                      </Link>
                    </SlideItemWrapper>
                  </SwiperSlide>
                )
            )}
          </SwiperSlider>
        </SwiperWrapper>
      </Container>
    </SectionWrapper>
  )
}

export default HomeArea
